import { useState, useCallback, useRef, useEffect } from "react";

const useDemandStudioTips = () => {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef(null);

  const toggleTips = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const closeTips = useCallback(() => {
    setIsOpen(false);
  }, []);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (anchorRef.current && !anchorRef.current.contains(event.target)) {
        closeTips();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, closeTips]);

  return { isOpen, anchorRef, toggleTips, closeTips };
};

export default useDemandStudioTips;
